import { api } from "../api";

export type TemplateChecklist = {
  id: number;
  pdcId: number;
  title: string;
  createdAt: Date;
};

export type TemplateChecklistItem = {
  id: number;
  templateChecklistId: number; // Atualizado conforme resposta da API
  content: string;
  isChecked: boolean;
  order: number;
  createdAt: Date;
};

export type CreateTemplateChecklistBody = Omit<TemplateChecklist, "id, createdAt">;

export type CreateTemplateChecklistItemBody = Omit<TemplateChecklistItem, "id, createdAt">;

// 🚀 NOVA INTERFACE: Criação completa de template
export type CreateCompleteTemplateRequest = {
  pdcId: number;           // ID da concessionária (obrigatório)
  title: string;           // Título do template (obrigatório)
  items: {                 // Array de itens (opcional, pode estar vazio)
    content: string;       // Conteúdo do item (obrigatório se item presente)
    order: number;         // Ordem de exibição (obrigatório, deve ser ≥ 0)
  }[];
};

// 🚀 INTERFACE DE RESPOSTA: Template criado com itens
export type CreateCompleteTemplateResponse = {
  id: number;
  pdcId: number;
  title: string;
  createdAt: string;
  templateChecklistItems: {
    id: number;
    templateChecklistId: number;
    content: string;
    order: number;
    createdAt: string;
  }[];
};

export type UpdateTemplateChecklistBody = Omit<TemplateChecklist, "createdAt, pdcId">;

export type UpdateTemplateChecklistItemBody = Omit<TemplateChecklistItem, "createdAt, templateChecklistId">;

export const getTemplateChecklistById = async (id: number) => {
  let url = `/templateChecklist/${id}`;
  return await api.get(url);
};

export const getTemplateChecklistsByPdcId = async (pdcId: number) => {
  let url = `/templateChecklist/pdc/${pdcId}`;
  return await api.get(url);
};

// 🚀 NOVA ROTA EFICIENTE: Busca TODOS os templates de uma vez
export const getAllTemplateChecklists = async () => {
  let url = `/templateChecklist/all`;
  return await api.get(url);
};

export const getTemplateChecklistItemsByChecklistId = async (checklistId: number) => {
  let url = `/templateChecklist/items/${checklistId}`;
  return await api.get(url);
};

export const createTemplateChecklist = async (body: CreateTemplateChecklistBody) => {
  let url = `/templateChecklist`;
  return await api.post(url, body);
};

export const createTemplateChecklistItem = async (body: CreateTemplateChecklistItemBody) => {
  let url = `/templateChecklist/items`;
  return await api.post(url, body);
};

export const updateTemplateChecklist = async (body: UpdateTemplateChecklistBody) => {
  let url = `/templateChecklist/${body.id}`;
  return await api.put(url, body);
};

export const updateTemplateChecklistItem = async (body: UpdateTemplateChecklistItemBody) => {
  let url = `/templateChecklist/items/${body.id}`;
  return await api.put(url, body);
};

export const deleteTemplateChecklist = async (id: number) => {
  let url = `/templateChecklist/${id}`;
  return await api.delete(url);
};

export const deleteTemplateChecklistItem = async (id: number) => {
  let url = `/templateChecklist/items/${id}`;
  return await api.delete(url);
};

// 🚀 NOVA ESTRATÉGIA: Criação completa em uma única requisição
export const createCompleteTemplate = async (body: CreateCompleteTemplateRequest) => {
  let url = `/templateChecklist/complete`;
  return await api.post(url, body);
}; 